import { GenericDocumentActionTypes } from "models/actionTypes/genericDocumentActionTypes";
import { ReduxConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";

export const genericDocumentSentBackApproved = (id: number): GenericDocumentActionTypes => {
  return {
    type: ReduxConstants.GenericDocumentActions.GENERIC_DOCUMENT_SENT_BACK_APPROVED,
    payload: id,
  };
};

export const genericDocumentSentBackSnoozed = (id: number): GenericDocumentActionTypes => {
  return {
    type: ReduxConstants.GenericDocumentActions.GENERIC_DOCUMENT_SENT_BACK_SNOOZED,
    payload: id,
  };
};

export const genericDocumentSentBackUpdated = (
  document: WintSuperkollAPIModel.GenericDocument
): GenericDocumentActionTypes => {
  return {
    type: ReduxConstants.GenericDocumentActions.GENERIC_DOCUMENT_SENT_BACK_UPDATED,
    payload: document,
  };
};
